import { type ReactNode } from 'react';
import { MenuItem } from '@headlessui/react';
import clsx from 'clsx';

import styles from './Dropdown.module.css';

interface DropdownItemProps {
  children: ReactNode;
  onClick?: () => void;
  href: string;
  active?: boolean;
  disabled?: boolean;
  className?: string;
}

export default function DropdownItem({
  children,
  onClick,
  href,
  active = false,
  disabled = false,
  className,
}: DropdownItemProps) {
  return (
    <MenuItem disabled={disabled}>
      <a
        href={href}
        onClick={onClick}
        className={clsx(
          styles.dropdownItem,
          active && styles.dropdownItemActive,
          disabled && styles.disabled,
          className,
        )}
      >
        {children}
      </a>
    </MenuItem>
  );
}
